import React from "react";
import { Dialog, DialogContent, Typography, Box, Button } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import MicOffIcon from "@mui/icons-material/MicOff";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
// import Button from '../Button';
import robotSvg from "../../assets/svgs/speechEvaluationIcons/robot.svg";
import closeIconSvg from "../../assets/svgs/closeIcon.svg";
import arrowSvg from "../../assets/svgs/arrow.svg";
import pauseSvg from "../../assets/svgs/pause.svg";

const useStyles = makeStyles()((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: theme.spacing(3),
      padding: theme.spacing(3),
      backgroundColor: theme.palette.background.default,
      maxWidth: 500,
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  icon: {
    fontSize: 80,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  message: {
    marginBottom: theme.spacing(3),
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  button: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(1, 3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: 156,
  },
  buttonIcon: {
    fontSize: 32,
    marginBottom: theme.spacing(1),
  },
}));

const RecordingInactivity = ({
  open,
  close,
  onPause,
  onContinue,
  title = "Are you Speaking?",
  message = "We haven't heard anything from you this time. What would you like to do?",
}) => {
  const { classes } = useStyles();

  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          background: "none",
          height: "100%",
          width: "100%",
          alignContent: "center",
          boxShadow: "none",
          justifyContent: "center",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <DialogContent
          sx={{
            borderRadius: 4,
            borderTop: "5px solid #FFAE00",
            position: "relative",
            background: "#ffffff",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 2,
            }}
          >
            <img style={{ width: "30%" }} src={robotSvg} alt="" />
          </Box>
          <Typography
            sx={{
              fontSize: "1.2em",
              fontFamily: '"Quicksand", sans-serif',
              fontWeight: "700",
              textAlign: "center",
              color: "#FF530A",
            }}
          >
            {title}
          </Typography>

          <Box sx={{ padding: 3 }}>
            <Typography
              sx={{
                fontSize: "0.9em",
                fontFamily: '"Quicksand", sans-serif',
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              {message}
            </Typography>
          </Box>
        </DialogContent>
        <Box
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
          }}
          onClick={() => close(!open)}
        >
          <img style={{ width: "70%" }} src={closeIconSvg} alt="" />
        </Box>
        <Box
          sx={{
            position: "absolute",
            bottom: "-30px",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Box
              sx={{
                background:
                  "linear-gradient(0deg, #CCCCCC -2.68%, #E6E6E6 31.68%, #F8F8F8 64.23%, #FFFFFF 87.74%)",
                padding: "5px",
                borderRadius: "30px",
              }}
            >
              <Button
                sx={{
                  background:
                    "linear-gradient(to top, #ff6300, #ff7c00, #ff9400, #ffaa00, #ffbf00)",
                  padding: "10px 40px",
                  borderRadius: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "15vh",
                  overflow: "hidden",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "50%", // Covers the top half of the button
                    background: "rgba(255, 255, 255, 0.3)", // Semi-transparent white for shine
                    borderRadius: "inherit", // Match button's border-radius
                    transform: "translateY(-60%)", // Position the shine near the top
                    filter: "blur(10px)", // Smoothens the shine effect
                    pointerEvents: "none", // Ensures the overlay doesn't interfere with button interactions
                  },
                  "&:hover": {
                    background:
                      "linear-gradient(to top, #ff6300, #ff7c00, #ff9400, #ffaa00, #ffbf00, #ffc80b, #ffd116, #ffda20, #ffd91a, #ffd814, #ffd60b, #ffd500)",
                    boxShadow: "0 6px 10px rgba(0, 0, 0, 0.3)", // Enhance the shadow on hover for a pop-out effect
                  },
                }}
                onClick={onPause}
              >
                <img
                  style={{
                    width: "25%",
                    maxWidth: "100%",
                    marginRight: "5px",
                    height: "auto",
                  }}
                  src={pauseSvg}
                  alt=""
                />
                <Typography
                  sx={{
                    fontSize: "1.5em",
                    fontFamily: '"Quicksand", sans-serif',
                    fontWeight: "700",
                    textAlign: "center",
                    color: "#ffffff",
                  }}
                >
                  Pause
                </Typography>
              </Button>
              {/* <Button onClick={handleAllow} variant="contained" placeholder="Allow Access" /> */}
            </Box>
            <Box
              sx={{
                background:
                  "linear-gradient(0deg, #CCCCCC -2.68%, #E6E6E6 31.68%, #F8F8F8 64.23%, #FFFFFF 87.74%)",
                padding: "5px",
                borderRadius: "30px",
              }}
            >
              <Button
                sx={{
                  background:
                    "linear-gradient(to top, #ff6300, #ff7c00, #ff9400, #ffaa00, #ffbf00, #ffc80b, #ffd116, #ffda20, #ffd91a, #ffd814, #ffd60b, #ffd500)",
                  padding: "10px 40px",
                  borderRadius: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "15vh",
                  overflow: "hidden",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "50%", // Covers the top half of the button
                    background: "rgba(255, 255, 255, 0.3)", // Semi-transparent white for shine
                    borderRadius: "inherit", // Match button's border-radius
                    transform: "translateY(-60%)", // Position the shine near the top
                    filter: "blur(10px)", // Smoothens the shine effect
                    pointerEvents: "none", // Ensures the overlay doesn't interfere with button interactions
                  },
                  "&:hover": {
                    background:
                      "linear-gradient(to top, #ff6300, #ff7c00, #ff9400, #ffaa00, #ffbf00)", // Slightly adjust the gradient on hover
                    boxShadow: "0 6px 10px rgba(0, 0, 0, 0.3)", // Enhance the shadow on hover for a pop-out effect
                  },
                }}
                onClick={onContinue}
              >
                <Typography
                  sx={{
                    fontSize: "1.5em",
                    fontFamily: '"Quicksand", sans-serif',
                    fontWeight: "700",
                    textAlign: "center",
                    color: "#ffffff",
                  }}
                >
                  Continue
                </Typography>
                <img
                  style={{
                    width: "30%",
                    maxWidth: "100%",
                    marginTop: "5px",
                    height: "auto",
                  }}
                  src={arrowSvg}
                  alt=""
                />
              </Button>
              {/* <Button onClick={handleAllow} variant="contained" placeholder="Allow Access" /> */}
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default RecordingInactivity;
